export default {
  documentType: [],
  entity: [],
  loading: false
};
